export const payload = {
  receiveMutation: 'RECEIVE_TAXCODES',
  receivingMutation: 'RECEIVING_TAXCODES',
  receiveMetadataMutation: 'RECEIVE_TAXCODE_METADATA',
  receiveFailureMutation: 'RECEIVE_TAXCODE_FAILURE',
  savingMutation: 'SAVING_TAXCODE',
  saveFailureMutation: 'SAVING_TAXCODE_FAILURE',
  incrementMutation: 'INCREMENT_TAXCODE_COUNT',
  updatingMutation: 'UPDATING_TAXCODE',
  updateFailureMutation: 'UPDATING_TAXCODE_FAILURE',
  deleteMutation: 'DELETE_TAXCODE',
  deletingMutation: 'DELETING_TAXCODE',
  deleteFailureMutation: 'DELETING_TAXCODE_FAILURE',
  resetMetaMutation: 'RESET_TAXCODE_META',
  clearMutation: 'CLEAR_TAXCODE_STATE',
  moduleName: 'taxcode',
  endpoint: 'countrytaxcodes',
  searchableFields: ['code', 'name', 'description']
}
